import { render, staticRenderFns } from "./loginAsToken.vue?vue&type=template&id=3efffedd"
import script from "./loginAsToken.vue?vue&type=script&lang=js"
export * from "./loginAsToken.vue?vue&type=script&lang=js"
import style0 from "./loginAsToken.vue?vue&type=style&index=0&id=3efffedd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports